import { jsx } from 'react/jsx-runtime';
import { Primitive } from '@radix-ui/react-primitive';
import { logger } from '../../../utils/logger.mjs';
import { useDatePickerContext } from '../context/datePickerContext.mjs';

const MODE_TOGGLE_TRIGGER_NAME = "ModeToggleTrigger";
const ModeToggleTrigger = (props) => {
  const { __scopeDatePicker, children, ...rest } = props;
  const { mode, onChangeMode } = useDatePickerContext(
    MODE_TOGGLE_TRIGGER_NAME,
    __scopeDatePicker
  );
  const handleClick = (e) => {
    rest.onClick?.(e);
    if (typeof onChangeMode === "function") {
      onChangeMode(mode === "range" ? "single" : "range");
    } else {
      logger.warn(
        "ModeToggleTrigger \uCEF4\uD3EC\uB10C\uD2B8\uB97C \uC0AC\uC6A9\uD558\uAE30 \uC704\uD574\uC11C\uB294 DatePicker\uC5D0\uAC8C onChangeMode\uB97C \uC804\uB2EC\uD574\uC57C\uD569\uB2C8\uB2E4."
      );
    }
  };
  return /* @__PURE__ */ jsx(Primitive.button, { ...rest, onClick: handleClick, children });
};

export { ModeToggleTrigger as default };
//# sourceMappingURL=ModeToggleTrigger.mjs.map
